import React, { Component } from 'react'
import FixedView from '../FixedView'
import StagesManager from '../StagesManager'
import IntractionActionsList from '../IntractionActionsList'

export default class SettingsCommerceUserMenu extends Component {

    changeWindow = (list) => {
        this.props.changeWindow(list)
        this.fixedView.hideView()
    }

    changeFrame = (item) => {
        // this.props.changePage(item)
        this.props.functionsHandler(null, 'changePage', [item])
        this.fixedView.hideView()
    }


    render() {

        let colors = this.props.colors

        return (
            <>
                <button className='mld-2 flexcc dark-blur-hover p-1 br-5' ref={el => this.setting = el} onClick={() => { this.fixedView.showView() }}>
                    <img width={24} className={(colors?.iconInvert ? 'invert' : '')} src='/assets/icons/applets/database/setting-white.svg' />
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.fixedView = el} nodeRef={this.setting} xOffset={219} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'ّfile'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className='mb-2'>
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Orders", shortcut: 'Ctrl+O', icon: "/assets/icons/note/file/open.svg" }} onClick={() => this.changeFrame('orders')} />
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Payments", shortcut: 'Ctrl+O', icon: "/assets/icons/note/file/open.svg" }} onClick={() => this.changeFrame('payments')} />
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Vouchers", icon: "/assets/icons/note/file/copy.svg" }} onClick={() => this.changeFrame('vouchers')} />
                                    {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Applet Permissions", icon: "/assets/icons/note/file/copy.svg" }} onClick={() => this.changeFrame('appletpermissions')} /> */}
                                </div>
                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Addresses", sub: true, icon: "/assets/icons/note/file/share.svg" }} onClick={() => this.changeFrame('addresses')} />
                                    {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Stages", sub: true, icon: "/assets/icons/note/file/email.svg" }} onClick={() => this.changeFrame('stages')} /> */}
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Whishlist", sub: true, icon: "/assets/icons/note/file/download.svg" }} onClick={() => this.changeFrame('whishlist')} />
                                    {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Variables", icon: "/assets/icons/note/file/move.svg" }} onClick={() => this.changeFrame('variables')} /> */}

                                    {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Stages", sub: true, icon: "/assets/icons/note/file/download.svg" }} onClick={() => this.props.functionsHandler(null, 'changeWindow', ["{{username}}", "{{appletSlug}}",'admin', 'settings','applet'])}/> */}
                                </div>
                                {/* <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Collections", icon: "/assets/icons/note/file/rename.svg" }} onClick={() => this.changeFrame('collections')} />
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Pages", icon: "/assets/icons/note/file/move.svg" }} onClick={() => this.changeFrame('pages')} />

                                </div>
                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.User Perspective", sub: true, icon: "/assets/icons/note/file/version.svg" }} onClick={() => this.changeFrame('pages')} />
                                </div> */}

                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList onClick={() => this.changeFrame('settings')} language={this.props.language} data={{ title: "{{lang}}Open Settings", icon: "/assets/icons/note/file/version.svg" }} />
                                </div>

                                {/* <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Help", icon: "/assets/icons/note/file/detail.svg" }} />
                                </div> */}
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
            </>
        )
    }
}
